export class ProductCode {
  public static STH = ['STMFULL', 'STMHALF'];
  public static Employees = 'Employees';
  public static Guardian = 'Guardian';
  public static Kids = 'Kids';
}
